import styled from 'styled-components';
import { IconSizesType } from '../ThemeProvider/types';

export const SvgContainer = styled.div<{
  size: IconSizesType;
  color: string;
  clickable: boolean;
  disabled: boolean;
}>`
  width: ${({ theme, size }) => theme.basicIcon[size].size}px;
  height: ${({ theme, size }) => theme.basicIcon[size].size}px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};

  & > svg path:not([class$='not-color']),
  & > svg circle:not([class$='not-color']),
  & > svg rect:not([class$='not-color']) {
    fill: ${({ color, disabled, theme }) => (disabled ? theme.grayCC : color)};
  }
`;
